import { Typography } from '@breetometer/components';
import { NotificationBannerAlertIcon } from 'BreetAssets';

import type { IStandardNotification } from '../NotificationBanner.helpers';

export const StandardNotification = ({ message, status }: IStandardNotification) => {
	if (!message) return null;

	const bgstatusClass = status === 'success' ? 'bg-success-800' : 'bg-dark-maroon';

	const statusClass = status === 'success' ? 'color-success-400' : 'color-light-coral-red';

	return (
		<div
			className={`notificationbanner ${status} ${bgstatusClass} standard`}
			data-testid='notification-banner'
		>
			<NotificationBannerAlertIcon status={status} />
			<Typography className={`${status} ${statusClass}`}>{message}</Typography>
		</div>
	);
};
